var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D8EFDEC1-1DC5-4C80-BD53-14C9B879C186@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---My-Information",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Personal---Edit-Hover",
    transform: "translate(-820.000000, -702.000000)",
    fill: "#2774AE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(269.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.845971,156 L567,160.153334 L556.485007,170.666667 L552.333333,166.513333 L562.845971,156 Z M570.581888,154.463828 L568.722024,152.55366 C568.003251,151.815447 566.836112,151.815447 566.114897,152.55366 L564.333333,154.38341 L568.503791,158.666667 L570.581888,156.532364 C571.139371,155.959763 571.139371,155.036389 570.581888,154.463828 Z M551.011828,171.419225 C550.934476,171.762238 551.248784,172.069596 551.596948,171.986178 L556.333333,170.854646 L552.085318,166.666667 L551.011828,171.419225 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.6a1baf263b0e3d0707a8800255898a52.svg";
export { ForwardRef as ReactComponent };